import { render, staticRenderFns } from "./ModalInventoryPO.vue?vue&type=template&id=723abd39"
import script from "./ModalInventoryPO.vue?vue&type=script&lang=js"
export * from "./ModalInventoryPO.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports